const eventViewServicePDP = (params, carModel, serviceType, categoryEntry) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'productDetail',
      eventCategory: `ecommerce ${serviceType === 'coupon' ? 'kupon' : 'paket'} servis`,
      eventLabel: categoryEntry,
      carModel: carModel?.toLowerCase() || 'not available',
      ecommerce: {
        currencyCode: 'IDR',
        detail: {
          products: [params],
        },
      },
    });
  }
};
export default eventViewServicePDP;
